export default __webpack_public_path__ + "static/media/homeFootball.5b70fef6.png";